"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePlugins = void 0;
var initializePlugins = function (plugins) {
  var pluginConfigs = plugins || [];
  return pluginConfigs.filter(function (config) {
    var pluginModule = config && config.plugin;
    var pluginFactory = pluginModule && pluginModule.default;
    return typeof pluginFactory === 'function';
  }).map(function (config) {
    var plugin = config.plugin,
      options = config.options;
    var pluginFactory = plugin.default;
    return pluginFactory(options);
  });
};
exports.initializePlugins = initializePlugins;